import { useTranslation, Trans } from "react-i18next";
import { ExternalLink, Smartphone, ArrowRight, Send } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { StepCard } from "./StepCard";
import { SendTokenForm } from "./SendTokenForm";

function OffRampParaguay() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="rounded-xl bg-gradient-to-r from-brand-500/10 to-success-500/10 p-4">
        <p
          className="text-sm text-text-secondary"
          dangerouslySetInnerHTML={{ __html: t("ramp.pyIntro") }}
        />
      </div>

      <div className="space-y-5">
        <StepCard
          step={1}
          title={t("ramp.step1ElDorado")}
          description={t("ramp.step1ElDoradoDesc")}
          icon={<Smartphone className="h-4 w-4 text-brand-500" />}
          action={
            <div className="flex flex-wrap gap-2">
              <a href="https://app.eldorado.io" target="_blank" rel="noopener noreferrer">
                <Button variant="secondary" size="sm" className="gap-1.5">
                  {t("ramp.openElDoradoWeb")}
                  <ExternalLink className="h-3 w-3" />
                </Button>
              </a>
              <a href="https://play.google.com/store/apps/details?id=io.eldorado" target="_blank" rel="noopener noreferrer">
                <Button variant="ghost" size="sm" className="gap-1.5 text-xs">
                  Google Play
                  <ExternalLink className="h-3 w-3" />
                </Button>
              </a>
              <a href="https://apps.apple.com/app/el-dorado-p2p/id1576616116" target="_blank" rel="noopener noreferrer">
                <Button variant="ghost" size="sm" className="gap-1.5 text-xs">
                  App Store
                  <ExternalLink className="h-3 w-3" />
                </Button>
              </a>
            </div>
          }
        />

        <StepCard
          step={2}
          title={t("ramp.step2GetAddress")}
          description={t("ramp.step2GetAddressDesc")}
          icon={<ArrowRight className="h-4 w-4 text-brand-500" />}
        />

        <StepCard
          step={3}
          title={t("ramp.step3Send")}
          description={t("ramp.step3SendDesc")}
          icon={<Send className="h-4 w-4 text-brand-500" />}
          action={<SendTokenForm title={t("ramp.sendToElDorado")} />}
        />

        <StepCard
          step={4}
          title={t("ramp.step4SellPYG")}
          description={t("ramp.step4SellPYGDesc")}
          icon={<ArrowRight className="h-4 w-4 text-brand-500" />}
        />
      </div>

      <div className="rounded-xl border border-warning-200 bg-warning-50 p-4 dark:border-warning-800 dark:bg-warning-950">
        <h4 className="text-sm font-semibold text-warning-700 dark:text-warning-400">
          {t("ramp.important")}
        </h4>
        <p
          className="mt-1 text-xs text-warning-600 dark:text-warning-500"
          dangerouslySetInnerHTML={{ __html: t("ramp.warningPolygon") }}
        />
      </div>

      <div className="rounded-xl border border-border-subtle p-4">
        <p className="text-xs text-text-muted">
          <Trans
            i18nKey="ramp.alternativeBinance"
            components={{
              binance: (
                <a
                  href="https://p2p.binance.com/trade/sell/USDT?fiat=PYG"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-500 underline"
                />
              ),
            }}
          />
        </p>
      </div>
    </div>
  );
}

export { OffRampParaguay };
